import { format } from "date-fns"
import { Children, isValidElement } from "react"
import StatusBox from "./statusbox"

interface TimelineProps {
  children: React.ReactNode;
}

export function Timeline({ children }: TimelineProps) {
  return (
    <div className="flex flex-col gap-8 relative">
      {Children.map(
        children,
        (child, index) =>
          child &&
          isValidElement(child) && (
            <div key={index} className="flex flex-row gap-4 items-center z-10">
              <div className="bg-white h-full flex items-center">
                <StatusBox status={child.props.status || "success"} size="md" />
              </div>
              <div className="flex-1">{child}</div>
            </div>
          ),
      )}
      <div className="w-[2px] h-full bg-blue-500 absolute top-0 left-3" />
    </div>
  )
}

interface TimelineItemProps {
  label: string;
  date: string;
  status?: "pending" | "success" | "failed" | "loading";
}

export function TimelineItem({ label, date }: TimelineItemProps) {
  return (
    <div className="flex flex-col">
      <div className="text-sm font-semibold">{label}</div>
      <div className="text-xs text-gray-500">
        {format(date, "MMM do, yyyy hh:ii a")}
      </div>
    </div>
  )
}
